import EnergyLabel from "../energyLabel/EnergyLabel";
import React, {Fragment} from "react";
import {IAttribute, ICartItemImage, ICartItemPrice} from "../../typescript-library";
import {useTranslation} from "react-i18next";

type ItemPriceType = {
  prices: ICartItemPrice[];
  itemAttributes: IAttribute[];
  images: ICartItemImage[];
};

const ItemPrice: React.FC<ItemPriceType> = ({itemAttributes, images, prices}) => {
  const {t} = useTranslation();
  const {advertise, price, quantity, retail} = prices.find((prc) => prc.quantity.from === 1) || prices[0];
  const energyEfficiency = itemAttributes.find((attrib) => attrib.itemAttributeId === 100361);
  const energyLabel = images.find((image) => !!image.energyLabel)?.energyLabel || undefined;

  return (
    <div className="item-card__price__wrapper">
      {!!energyEfficiency && (
        <EnergyLabel energyClass={energyEfficiency.value ?? "G"} size={"small"} media={energyLabel} />
      )}
      <span className="item-card__price">
        {quantity.from > 1 && <span>{t("general.up")}&nbsp;</span>}
        {advertise && (
          <Fragment>
            <s>{t("general.rrp--price", {price: retail.formatted})}</s>{" "}
          </Fragment>
        )}
        <div className={advertise ? "red" : undefined}>
          <span>{price.formatted}</span>
          <sup className="footnote-reference">*</sup>
        </div>
      </span>
    </div>
  );
};

export default ItemPrice;
